import { IntegrationCode, IntegrationCodeType } from 'src/lib/fliko/enums/integrationCode';
import { ToString } from 'src/lib/fliko/helpers/toString.helper';
import { EstateData } from 'src/lib/fliko/models/estate/estate.data';
import { ExcelFile, ExcelFileFactory } from 'src/app/shared/factories/excel-file.factory';
import { LocalizationHelper } from 'src/app/shared/helpers/localization.helper';
import { style, width } from 'src/app/shared/helpers/table.constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { UserCommList } from '../services/models/users-table.data';

type ResidentExportRows = {
  [key in IntegrationCodeType]: string;
} & {
  name: string;
  lastName: string;
  email: string;
  ownerCode: string;
};

export class SuperAdminResidentsExportReport {
  private landlordsExport: ResidentExportRows[] = [];
  private tenantsExport: ResidentExportRows[] = [];

  private readonly locHelper = new LocalizationHelper(this.ls);

  constructor(
    private ls: LocalizationService,
    private estate: EstateData,
    private landlords: UserCommList.ResidentElement[],
    private tenants: UserCommList.ResidentElement[]
  ) {}

  public generateReport(): void {
    this.prepareData();
    const eg = new ExcelFileFactory();
    const hOpt = { height: 50 };

    eg.addSheet('Właściciele', residentColumns(), this.landlordsExport, this.ls, hOpt);

    eg.addSheet('Lokatorzy', residentColumns(), this.tenantsExport, this.ls, hOpt);

    eg.saveToFile(`${this.estate.id}_mieszkancy_do_importu_${this.locHelper.localizeDate(Date.now(), 'dShort')}`);
  }

  private prepareData(): void {
    this.landlordsExport = [];
    this.tenantsExport = [];

    this.parseTable(this.landlords, this.landlordsExport);
    this.parseTable(this.tenants, this.tenantsExport);
  }

  private parseTable(tab: UserCommList.ResidentElement[], to: ResidentExportRows[]): void {
    for (const data of tab) {
      const res = data.resident;
      const codes: any = {};
      for (const key of IntegrationCode.enumValues()) {
        codes[key] = res.residentCodes?.[key as IntegrationCodeType] ?? '';
      }
      to.push({
        name: res.name,
        lastName: res.lastName ?? '',
        email: ToString.getEmail(res),
        ownerCode: res.ownerCode ?? '',
        ...codes
      });
    }
  }
}

function residentColumns(): ExcelFile.Column[] {
  const codesColumns: ExcelFile.Column[] = [];
  for (const val of IntegrationCode.enumValues()) {
    codesColumns.push({ header: { key: val }, key: val, width: width(200), style });
  }
  return [
    { header: { key: 'user.name' }, key: 'name', width: width(250), style },
    { header: { key: 'user.surname' }, key: 'lastName', width: width(250), style },
    { header: { key: 'label.email' }, key: 'email', width: width(255), style },
    ...codesColumns
  ];
}
